import { render, staticRenderFns } from "./rk-dropdown-item.vue?vue&type=template&id=7fb4c6b3&"
import script from "./rk-dropdown-item.vue?vue&type=script&lang=ts&"
export * from "./rk-dropdown-item.vue?vue&type=script&lang=ts&"
import style0 from "./rk-dropdown-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports